import NewSubmissionModal from './NewSubmissionModal'

export default NewSubmissionModal